import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import Icon from "nekrasovka-ui/Icons";
import { useWindowDimensions } from "containers/WindowDimensions";
import LogosContainer from "components/LogosContainer";
import IconsGroup from "components/IconsGroup";
import Separator from "components/Separator";
import MenuModal from "components/MenuModal";
import { connect } from "react-redux";
import { fetchAddresses } from "../../modules/addresses/actions";

const SectionInner = styled.header`
  background-color: #40677e;
  padding: 0 20px;
`;

const StyledHeader = styled.div`
  max-width: 1220px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;

  color: #edeee9;
`;

const HeaderTop = styled.section`
  display: flex;
  justify-content: space-between;
  height: 92px;
  align-items: center;

  & > div:nth-child(2) {
    display: flex;
    align-items: center;

    & > div:last-child {
      display: flex;
      align-items: center;

      & svg {
        &:not(:last-child) {
          margin-right: 25px;
        }

        @media (max-width: 568px) {
          height: 25px;
          width: 25px;
        }
      }
    }
  }

  @media (max-width: 568px) {
    height: 85px;
  }
`;

const HeaderTopMenu = styled.div`
  display: flex;
  margin-right: 30px;

  & a {
    font-family: Rubik, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px !important;
    line-height: 18px;

    &:not(:last-child) {
      margin-right: 20px;
    }

    &:hover {
      color: #ffad20;
    }
  }
`;

const HeaderBottom = styled.section`
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: space-between;

  & p,
  & a {
    font-family: Rubik, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #edeee9;
  }

  & > div:nth-child(2) {
    display: flex;
    height: 100%;
    align-items: center;

    & > div:nth-child(1) {
      width: 220px;
      text-align: right;

      & p {
        font-size: 13px;
        line-height: 15px;
      }
    }
  }

  @media (max-width: 568px) {
    height: 60px;
  }
`;

const HeaderBottomMenu = styled.div`
  display: flex;
  flex-wrap: wrap;

  & a {
    font-size: 18px;
    line-height: 25px;

    &:not(:last-child) {
      margin-right: 20px;
    }

    &:hover {
      color: #ffad20;
    }
  }
`;

const Header = ({ fetchAddresses, data, loading }) => {
  const { width } = useWindowDimensions();
  const [isModalOpened, setIsModalOpened] = useState(false);

  useEffect(() => {
    fetchAddresses();
  }, []);

  const titles = [
    [
      { url: "https://nekrasovka.ru/articles/guest", text: "Посетителям" },
      { url: "https://nekrasovka.ru/articles/collegue", text: "Коллегам" },
      { url: "https://nekrasovka.ru/articles/library", text: "О библиотеке" },
      { url: "https://biblioteka.nekrasovka.ru/addresses", text: "Адреса" },
    ],
    [
      { url: "https://opac.nekrasovka.ru/vmk/", text: "Каталог" },
      { url: "https://nekrasovka.ru/afisha", text: "Афиша" },
      { url: "https://biblioteka.nekrasovka.ru/event", text: "Проекты" },
      { url: "https://nekrasovka.ru/books", text: "Журнал" },
      { url: "https://nekrasovka.ru/clubs", text: "Клубы" },
      { url: "https://electro.nekrasovka.ru/", text: "Электронекрасовка" },
    ],
  ];

  return (
    <Fragment>
      {isModalOpened && (
        <MenuModal
          setIsModalOpened={setIsModalOpened}
          width={width}
          data={data}
          loading={loading}
        />
      )}
      <SectionInner>
        <StyledHeader>
          <HeaderTop>
            <LogosContainer />
            <div>
              {width > 950 && (
                <HeaderTopMenu>
                  {titles[0].map((title, i) => {
                    return (
                      <a href={title.url} key={i}>
                        {title.text}
                      </a>
                    );
                  })}
                </HeaderTopMenu>
              )}
              <div>
                <Icon
                  icon="menu"
                  width={30}
                  height={30}
                  fill="#EDEEE9"
                  onClick={() => setIsModalOpened(true)}
                />
              </div>
            </div>
          </HeaderTop>
          <Separator />
          <HeaderBottom>
            {width > 569 && (
              <div>
                {width < 950 && (
                  <HeaderTopMenu>
                    {titles[0].map((title, i) => {
                      return (
                        <a href={title.url} key={i}>
                          {title.text}
                        </a>
                      );
                    })}
                  </HeaderTopMenu>
                )}
                <HeaderBottomMenu>
                  {titles[1].map((title, i) => {
                    return (
                      <a href={title.url} key={i}>
                        {title.text}
                      </a>
                    );
                  })}
                </HeaderBottomMenu>
              </div>
            )}
            <div>
              {width > 700 && (
                <div>
                  <p>
                    Сведения об организации, осуществляющей образовательную
                    деятельность
                  </p>
                </div>
              )}
              {width > 950 && (
                <Separator separatorStyle="height: calc(100% - 30px); width: 1px; margin: 0 15px;" />
              )}
              {width > 950 && <IconsGroup />}
              {width < 568 && (
                <IconsGroup iconsGroupStyle="& a {& svg {height: 20px !important; width: 20px !important;} &:not(:last-child) {margin-right: 8px !important;}};" />
              )}
            </div>
          </HeaderBottom>
        </StyledHeader>
      </SectionInner>
    </Fragment>
  );
};

const mapStateToProps = ({ addresses: { data, loading } }) => ({
  data,
  loading,
});

export default connect(mapStateToProps, { fetchAddresses })(Header);



// WEBPACK FOOTER //
// ./src/containers/Header/index.js